<!-- Header -->
<h2 mat-dialog-title class="mat-title">
  <span >{{title}}</span>
  <span class="close-dialog" (click)="close()">&#10006;</span>
</h2>

<mat-dialog-content>
<form>

  <mat-form-field floatLabel="always" appearance="outline">
     <mat-label>{{ 'COMPANY_ADD_USERS.email' | translate }}</mat-label>
    <input
      placeholder="{{ 'COMPANY_ADD_USERS.enter_email' | translate }}"
      [formControl]="inputValue"
      type="text"
      matInput
    />
    @if (inputValue.errors && (inputValue.errors.required || inputValue.errors.email)) {
      <mat-error>
        {{ 'COMPANY_ADD_USERS.email_error' | translate }}
      </mat-error>
    }
  </mat-form-field>
</form>
</mat-dialog-content>
<!--Footer-->
<mat-dialog-actions align="end">
  <button mat-stroked-button color="primary" mat-button="" mat-dialog-close>{{"COMPANY_ADD_USERS.cancel" | translate}}</button>
  <button mat-raised-button color="primary" (click)="recoverUser()" [disabled]="checkEmail()">
    {{title}}
  </button>
</mat-dialog-actions>
